import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import firebase from "firebase/compat";
import firebaseService from "services/firebase";
import { UPLOAD_STATUS } from "../types";
import { generateUploadProgress } from "../utilies";
import FileItem from "../FileItem";

const Uploader = ({ folder = "missing-folder-name" }) => {
  const [uploadedFiles, setUploadedFiles] = useState({});

  const uploadFileToStorage = (file, originFileList) => {
    const storageRef = firebaseService.storage.ref();
    const { id, fileData, fileName } = file;
    const fileRef = storageRef.child(fileName);

    const uploadTask = fileRef.put(fileData);
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        const { bytesTransferred, totalBytes } = snapshot;
        const progress = generateUploadProgress({ bytesTransferred, totalBytes });
        if (originFileList[id].progress !== progress) {
          originFileList[id] = {
            ...originFileList[id],
            progress,
            status: snapshot.state,
          };
          setUploadedFiles({
            ...originFileList,
            ...uploadedFiles,
          });
        }
      },
      (error) => {
        originFileList[id] = {
          ...originFileList[id],
          status: UPLOAD_STATUS.error,
          error,
          progress: 0,
        };
        setUploadedFiles({
          ...originFileList,
          ...uploadedFiles,
        });
      },
      () => {
        originFileList[id] = {
          ...originFileList[id],
          status: UPLOAD_STATUS.success,
        };
        setUploadedFiles({
          ...originFileList,
          ...uploadedFiles,
        });
      }
    );
  };

  const retry = (file) => {
    const storageRef = firebaseService.storage.ref();
    const { id, fileData, fileName } = file;
    const fileRef = storageRef.child(fileName);
    const uploadTask = fileRef.put(fileData);

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        const { bytesTransferred, totalBytes } = snapshot;
        const progress = generateUploadProgress({ bytesTransferred, totalBytes });
        if (uploadedFiles[id].progress !== progress) {
          setUploadedFiles({
            ...uploadedFiles,
            [id]: {
              ...uploadedFiles[id],
              progress,
              status: snapshot.state,
              error: undefined,
            },
          });
        }
      },
      (error) => {
        setUploadedFiles({
          ...uploadedFiles,
          [id]: {
            ...uploadedFiles[id],
            status: UPLOAD_STATUS.error,
            error,
            progress: 0,
          },
        });
      },
      () => {
        setUploadedFiles({
          ...uploadedFiles,
          [id]: {
            ...uploadedFiles[id],
            status: UPLOAD_STATUS.success,
          },
        });
      }
    );
  };

  const formatFile = (file) => {
    const { name, lastModified } = file;
    const id = uuidv4();
    const timestamp = moment().unix();
    const fileName = `${folder}/${timestamp}-${name}`;
    return { name, lastModified, id, status: UPLOAD_STATUS.default, progress: 0, timestamp, fileName };
  };

  const handleFileEvent = (e) => {
    const files = e.target.files;
    const fileArray = Array.from(files);
    const formattedFiles = fileArray.reduce((result, file) => {
      const formattedFile = formatFile(file);
      return {
        ...result,
        [formattedFile.id]: {
          ...formattedFile,
          fileData: file,
        },
      };
    }, {});

    Object.values(formattedFiles).forEach(async (file) => {
      uploadFileToStorage(file, formattedFiles);
    });
  };

  return (
    <div className="uploader-container mt-2">
      <label htmlFor="fileUpload">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a className="button is-primary">CHOOSE FILES</a>
      </label>
      <input
        className="upload-input"
        id="fileUpload"
        onChange={handleFileEvent}
        type="file"
        multiple
        accept="application/pdf, image/png"
      />
      <div className="uploader-list">
        {Object.values(uploadedFiles).map((file) => (
          <FileItem file={file} key={file.id} retry={retry} />
        ))}
      </div>
    </div>
  );
};

export default Uploader;
